import React, { useState, MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';

import Button from 'components/Shared/Button/Button';
import Spinner from 'components/Shared/Spinner/Spinner';
import { colors } from 'styles/cp';

interface EstimateActionButtonsProps {
  acceptHandler: () => void;
  declineHandler: (event: MouseEvent) => void;
}

const EstimateActionButtons: React.FC<EstimateActionButtonsProps> = ({
  acceptHandler,
  declineHandler,
}) => {
  const [isAcceptInProcess, setIsAcceptInProcess] = useState(false);

  const accept = async (event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    setIsAcceptInProcess(true);
    await acceptHandler();
    setIsAcceptInProcess(false);
  };

  return (
    <>
      <Button
        aria-label="Accept"
        disabled={isAcceptInProcess}
        buttonType="primary"
        size="jumbo"
        width="100%"
        onClick={accept}
      >
        {isAcceptInProcess && (
          <Spinner
            color={colors.green}
            label={''}
            bgStrokeWidth={2.5}
            width={25}
            strokeWidth={5}
            bgColor={colors.gray08}
          />
        )}
        {!isAcceptInProcess && <FormattedMessage id="ACCEPT" defaultMessage="Accept" />}
      </Button>
      <div className="decline-container">
        <Button
          aria-label="Decline"
          disabled={isAcceptInProcess}
          buttonType="tertiary"
          size="jumbo"
          width="100%"
          onClick={declineHandler}
        >
          <FormattedMessage id="DECLINE" defaultMessage="Decline" />
        </Button>
      </div>
      <style jsx>{`
        .decline-container,
        .change-container {
          margin: 8px 0;
        }
      `}</style>
    </>
  );
};

export default EstimateActionButtons;
